<script setup>
  import { computed, ref } from 'vue'

  const emit = defineEmits(['resetSubmenu'])
  const activeChildren = ref(undefined)
  const submenuActive = ref(false)

  defineProps({
    items: Object,
    open: Boolean
  })

  const closeSubmenu = () => {
    emit('resetSubmenu')
  }

  const setSubmenu = (item) => {
    submenuActive.value = !submenuActive.value
    if (submenuActive.value) {
      activeChildren.value = item.children
    }
  }

  const resetSubmenuSecond = () => {
    submenuActive.value = false
    activeChildren.value = undefined
  }


</script>

<template>
<transition
   name="slide-left"
   mode="out-in"
>
  <div
    v-if="open"
    class="flyout-menu-submenu overflow-scroll transition-all duration-300 ease-in-out absolute top-0 w-screen h-screen bg-primary z-50"
  >
    <ul>
      <li
        class="close-submenu"
      >
        <button
          @click="closeSubmenu"
          class="flex flex-row w-full px-6 items-center justify-start border-b border-white/30"
        >
          <AppIcon
            class="!bg-transparent rotate-90 translate-y-2"
            name="Chevron"
          />
          <span
            class="!text-white !bg-transparent py-5 text-sm"
          >
            Zurück
          </span>
        </button>
      </li>
      <li
        v-for="(item, index) in items"
        :key="index"
        class="menu-item-submenu pl-6 font-light flex flex-row items-center justify-between border-b first:border-t !border-white/30"
      >
        <a
          class="!text-white py-5 text-xl"
          :href="item.url"
        >
          {{ item.title }}
        </a>
        <button
          v-if="item.children"
          class="flex flex-row items-center border-x !border-white/30 px-3 py-5"
          @click="setSubmenu(item)"
        >
          <AppIcon
            class="!bg-transparent"
            name="Chevron"
          />
        </button>
      </li>
    </ul>
    <FlyoutMobileSubmenu
      :items="activeChildren"
      :open="submenuActive"
      @resetSubmenu="resetSubmenuSecond"
    />
  </div>
</transition>
</template>

<style lang="scss" scoped>
  .slide-left-enter-active, .slide-left-leave-active {
    transition: left 0.5s ease;
    left: 0;
  }
  .slide-left-enter-from, .slide-left-leave-to {
    left: 100%;
  }

  .close-submenu :deep(svg) {
    @apply h-3 w-auto mr-4;
  }
  .close-submenu :deep(svg path) {
    fill: #fff !important;
  }

  .menu-item-submenu :deep(svg) {
    @apply h-4 -rotate-90;
  }
  .menu-item-submenu :deep(svg path) {
    fill: #fff !important;
  }
</style>
